import { ReactElement } from "react";
import { IconButton } from "../IconButton/IconButton";
import { IconValue } from "../Icon/Icon";

export type MoreInfoProps = {
	onClick(): void;
	trackingId?: string;
};

export const MoreInfo = (props: MoreInfoProps): ReactElement => {
	const {
		onClick,
		trackingId
	} = props;

	return (
		<IconButton
			kind="transparent-colored"
			onClick={onClick}
			trackingId={trackingId}
			icon={icon}
		/>
	);
};
MoreInfo.displayName = "MoreInfo";

const icon: IconValue = {
	kind: "font",
	name: "circle-info",
	color: "primary"
};
